import React from 'react';

import { NavLink as RouterNavLink } from 'react-router-dom';

export const SidebarNavLink = React.forwardRef((props, ref) => <RouterNavLink innerRef={ref} {...props} />);
